module.exports = __webpack_public_path__ + "img/17.3387bb41.png";